/**
 * @generated SignedSource<<c9a6f6395bb55171049f5f12418a723f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRequest = {
  id: string;
};
export type DeleteCommentConfirmDialogMutation$variables = {
  input: DeleteRequest;
};
export type DeleteCommentConfirmDialogMutation$data = {
  readonly deleteComment: {
    readonly id: string;
  };
};
export type DeleteCommentConfirmDialogMutation = {
  response: DeleteCommentConfirmDialogMutation$data;
  variables: DeleteCommentConfirmDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Comment",
    "kind": "LinkedField",
    "name": "deleteComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCommentConfirmDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCommentConfirmDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f1f96df884232e0796a1c44f723d7d13",
    "id": null,
    "metadata": {},
    "name": "DeleteCommentConfirmDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCommentConfirmDialogMutation(\n  $input: DeleteRequest!\n) {\n  deleteComment(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "90ab6a6586abd976edf9c5cefc1634b4";

export default node;
